module.exports = __webpack_public_path__ + "static/3d-visual-2-839400ae212a87de452e63f6b39e6c1a.jpeg";